import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HelpPageComponent} from '../../help-page.component';
import {environment} from '../../../../../../environments/environment';

@Component({
    selector: 'app-help-page-notification',
    templateUrl: './help-page-notification.component.html',
    styleUrls: ['./help-page-notification.component.scss', '../../helpPageModule.scss'],
    standalone: false
})

export class HelpPageNotificationComponent extends HelpPageComponent implements OnInit
{
    constructor(trans: TranslateService)
    {
        super(trans);
    }

    ngOnInit(): void
    {
    }
    public readonly environment = environment;
}
